import script from "./FlagsView.vue?vue&type=script&setup=true&lang=js"
export * from "./FlagsView.vue?vue&type=script&setup=true&lang=js"

import "./FlagsView.vue?vue&type=style&index=0&id=b2294ace&scoped=true&lang=postcss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b2294ace"]])

export default __exports__